import SectionContainer from "../components/SectionContainer";

// Note: Google for Startups requires direct LinkedIn links here, and each profile
// must list "Shadow" / "ShadowLabs" under its Experience section.
const TEAM = [
  {
    name: "Shubham Gupta",
    role: "CEO",
    subheader: "IIT Delhi · Ex-Sanas",
    photo: "/images/landing-v2/team/shubham.jpeg",
    linkedin: "https://www.linkedin.com/in/shubham16180/",
  },
  {
    name: "Mayank Gupta",
    role: "CTO",
    subheader: "IIT Roorkee · Ex-Vyapar",
    photo: "/images/landing-v2/team/mayank.jpeg",
    linkedin: "https://www.linkedin.com/in/mayank-gupta-pm/",
  },
  {
    name: "Hersh Singh",
    role: "GTM",
    subheader: "Ex-Sanas",
    photo: "/images/landing-v2/team/hersh.jpeg",
    linkedin: "https://www.linkedin.com/in/hersh-singh-944234166/",
  },
  {
    name: "Priyansh Agrawal",
    role: "Founding Engineer",
    subheader: "IIT Delhi · Ex-Samsung Research",
    photo: "/images/landing-v2/team/priyansh.jpeg",
    linkedin: "https://www.linkedin.com/in/priyansh-agrawal-72192b195/",
  },
];

function initials(name) {
  return name
    .split(" ")
    .map((part) => part[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
}

function TeamCard({ name, role, subheader, photo, linkedin }) {
  return (
    <div className="group flex flex-col items-center rounded-2xl border border-neutral-100 bg-white p-7 text-center shadow-[0_2px_12px_rgba(0,0,0,0.06)] transition-all duration-300 hover:shadow-[0_8px_32px_rgba(0,0,0,0.10)] hover:-translate-y-1">
      <div className="relative h-24 w-24 overflow-hidden rounded-2xl bg-gradient-to-br from-[#0092B4] to-[#005f78] sm:h-28 sm:w-28">
        <span className="absolute inset-0 flex items-center justify-center text-xl font-bold text-white">
          {initials(name)}
        </span>
        {photo ? (
          <img
            src={photo}
            alt={name}
            loading="lazy"
            className="relative h-full w-full object-cover"
            onError={(e) => { e.currentTarget.style.display = "none"; }}
          />
        ) : null}
      </div>
      <h3 className="mt-4 text-[15px] font-semibold tracking-tight text-neutral-900">{name}</h3>
      <p className="mt-1 text-[13px] font-medium text-[#0092B4]">{role}</p>
      <p className="mt-0.5 text-[12px] text-neutral-400">{subheader}</p>
      <a
        href={linkedin}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`${name} on LinkedIn`}
        className="mt-4 inline-flex h-8 w-8 items-center justify-center rounded-full border border-neutral-200 bg-white transition-all hover:border-[#0092B4]/30 hover:shadow-[0_0_0_3px_rgba(0,146,180,0.08)]"
      >
        <img src="/images/landing-v2/team/linkedin.svg" alt="LinkedIn" className="h-4 w-4" />
      </a>
    </div>
  );
}

export default function TeamSection() {
  return (
    <SectionContainer id="team" className="py-20 sm:py-28">
      <div className="mx-auto max-w-3xl text-center">
        <h2 className="text-[clamp(1.6rem,3.5vw,2.5rem)] font-bold leading-[1.15] tracking-tight text-neutral-900">
          Built by operators who've{" "}
          <span className="text-[#0092B4]">seen this problem firsthand.</span>
        </h2>
        <p className="mt-4 text-base text-neutral-500">
          Sanas pioneered real-time voice AI for enterprise sales. That foundation — and that
          obsession with what happens live on the call — is baked into Shadow.
        </p>
      </div>

      <div className="mx-auto mt-12 grid max-w-5xl grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {TEAM.map((member) => (
          <TeamCard key={member.name} {...member} />
        ))}
      </div>
    </SectionContainer>
  );
}
